import { render, staticRenderFns } from "./Phds.vue?vue&type=template&id=19df2864&scoped=true&"
import script from "./Phds.vue?vue&type=script&lang=js&"
export * from "./Phds.vue?vue&type=script&lang=js&"
import style0 from "./Phds.vue?vue&type=style&index=0&id=19df2864&prod&lang=css&"
import style1 from "./Phds.vue?vue&type=style&index=1&id=19df2864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df2864",
  null
  
)

export default component.exports